/*jslint nomen: true */
'use strict';

var $ = require('jquery');
var stickyPanel = require('../../productdetail/sticky-panel');
var optiExperiment = require('../../components/optimizelyExperimentation');

function pdpsize(scopeClass) {
    //fix to show correct US size
    var isUSSelected = $(scopeClass + ' .attribute.size .sizes-wrapper .RegionGroup.active').hasClass('USgroup');
    if (isUSSelected) {
        var $selectedSizeItem = $(scopeClass + ' .attribute.size .sizes-wrapper .RegionGroup.active.USgroup').find(
            'li.selected'
        );

        if ($selectedSizeItem.length > 0) {
            var selectedSizeVal = $selectedSizeItem.find('.size-top').text();
            $(scopeClass + ' .attribute.size .selection-text').text(selectedSizeVal);
        }
    }

    let $scopedDropdown = $(scopeClass + ' .attribute-dropdown');
    $scopedDropdown.off('keydown');
    $scopedDropdown.on('keydown', function (e) {
        if (e.keyCode === 13) {
            $(scopeClass + ' .attribute-dropdown .selection').click();
        }
    });

    let $scopedSelection = $(scopeClass + ' .attribute-dropdown .selection');
    $scopedSelection.off('click');
    $scopedSelection.on('click', function () {
        var isPDP = $('.pdp-main').length > 0;
        if (isPDP) {
            $(scopeClass + ' .sizes-wrapper').toggle('medium', function () {
                // Animation complete.
                stickyPanel.scrollToContent();
            });
        } else {
            $(scopeClass + ' .sizes-wrapper').toggle('medium');
        }

        $(scopeClass + ' .selection-icon-down').toggleClass('active');
        $(scopeClass + ' .selection-icon-up').toggleClass('active');
        $(scopeClass + ' .attribute-dropdown').toggleClass('blue');

        if (
            $(scopeClass + ' #uniform-EU')
                .children()
                .hasClass('checked')
        ) {
            $(scopeClass + ' .EUgroup').addClass('activeSize');
            $(scopeClass + ' .UKgroup').removeClass('activeSize');
            $(scopeClass + ' .USgroup').removeClass('activeSize');
        }
        if (
            $(scopeClass + ' #uniform-UK')
                .children()
                .hasClass('checked')
        ) {
            $(scopeClass + ' .EUgroup').removeClass('activeSize');
            $(scopeClass + ' .UKgroup').addClass('activeSize');
            $(scopeClass + ' .USgroup').removeClass('activeSize');
        }
        if (
            $(scopeClass + ' #uniform-US')
                .children()
                .hasClass('checked')
        ) {
            $(scopeClass + ' .EUgroup').removeClass('activeSize');
            $(scopeClass + ' .UKgroup').removeClass('activeSize');
            $(scopeClass + ' .USgroup').addClass('activeSize');
        }
    });
}

function pdpeunumbers(scopeClass) {
    let $scopedRegion = $(scopeClass + ' .region-select #EU');
    $scopedRegion.off('click');
    $scopedRegion.on('click', function () {
        $(scopeClass + ' .EUgroup').addClass('activeSize');
        $(scopeClass + ' .UKgroup').removeClass('activeSize');
        $(scopeClass + ' .USgroup').removeClass('activeSize');
    });
}
function pdpuknumbers(scopeClass) {
    let $scopedRegion = $(scopeClass + ' .region-select #UK');
    $scopedRegion.off('click');
    $scopedRegion.on('click', function () {
        $(scopeClass + ' .EUgroup').removeClass('activeSize');
        $(scopeClass + ' .UKgroup').addClass('activeSize');
        $(scopeClass + ' .USgroup').removeClass('activeSize');
    });
}
function pdpusnumbers(scopeClass) {
    let $scopedRegion = $(scopeClass + ' .region-select #US');
    $scopedRegion.off('click');
    $scopedRegion.on('click', function () {
        $(scopeClass + ' .EUgroup').removeClass('activeSize');
        $(scopeClass + ' .UKgroup').removeClass('activeSize');
        $(scopeClass + ' .USgroup').addClass('activeSize');
    });
}

async function initOptimizelyExperiments() {
    const result = await optiExperiment.decideFeatureFlagVariation('pdp');

    if (result.variationKeySizing === 'treatment_1') {
        // EU and US sizes combined
        $('.nav-tabs-regions-selector').hide();
        $('.swatches').addClass('m-feature-testing-combined m-feature-testing-combined-horizontal');
        $('.region-select#US-group').find('.tab-link').trigger('click');
    } else if (result.variationKeySizing === 'treatment_2') {
        // EU and US sizes combined
        $('.nav-tabs-regions-selector').hide();
        $('.swatches').addClass('m-feature-testing-combined m-feature-testing-combined-vertical');
        $('.region-select#US-group').find('.tab-link').trigger('click');
    }
}

module.exports = {
    init: function (scopeClass, context) {
        var actualScopeClass = scopeClass || '';

        pdpsize(actualScopeClass);
        pdpeunumbers(actualScopeClass);
        pdpuknumbers(actualScopeClass);
        pdpusnumbers(actualScopeClass);

        if (context !== 'quickshop') {
            initOptimizelyExperiments();
        }
    }
};
